import getClient from './getClient'

export default function getSession() {
  return getClient().auth.getSession()
}
